import { render, staticRenderFns } from "./hzxxTJ.vue?vue&type=template&id=632610ee&scoped=true"
import script from "./hzxxTJ.vue?vue&type=script&lang=js"
export * from "./hzxxTJ.vue?vue&type=script&lang=js"
import style0 from "./hzxxTJ.vue?vue&type=style&index=0&id=632610ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632610ee",
  null
  
)

export default component.exports